<template>
  <div class="quiz-group">
    <div class="siimple-h5">{{ heading }}</div>
    <div v-if="!disableRuler" class="siimple-rule" />
    <div class="siimple-table siimple-table--fixed">
      <div class="siimple-table-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuizGroup',
  props: {
    heading: {
      type: String,
      required: false,
      default: null
    },
    disableRuler: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/QuizGroup.vue